import { render, staticRenderFns } from "./census-detail.vue?vue&type=template&id=28ac386e"
import script from "./census-detail.vue?vue&type=script&lang=ts"
export * from "./census-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports